import React from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';

const gradientTextStyle = {
    background: 'linear-gradient(to right, #ff0000 5%, #ff8c00 10%, #ffd700 65%, #ff69b4 85%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
};

const shineStyles = `
    .shine-effect {
        position: absolute;
        top: 0;
        left: -100%;
        width: 50%;
        height: 100%;
        background: linear-gradient(
            to right,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0) 100%
        );
        transform: skewX(-25deg);
        animation: shine 3s infinite;
        z-index: 1;
    }

    @keyframes shine {
        0% {
            left: -100%;
        }
        100% {
            left: 200%;
        }
    }
`;

const styleSheet = document.createElement("style");
styleSheet.innerText = shineStyles;
document.head.appendChild(styleSheet);

function ContactForm() {
    const [submitStatus, setSubmitStatus] = React.useState({
        text: 'Submit',
        color: 'black'
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = {
            name: formData.get('name'),
            phone: formData.get('phone'),
            email: formData.get('email'),
            message: formData.get('message')
        };

        try {
            const requestBody = {
                to: "shuhada@crescovent.com",
                from: "Sales@crescovent.com",
                subject: "New Contact Inquiry from Cresco Website",
                html: `<div style=\"font-family:Arial,sans-serif;max-width:600px;padding:20px;border:1px solid #ddd;border-radius:5px\"><h2 style=\"background-color:#9b2c2c;color:#fff;padding:10px;text-align:center\">New Inquiry from Cresco Website</h2><p><strong>Name:</strong> ${data.name}</p><p><strong>Phone Number:</strong> ${data.phone}</p><p><strong>Email:</strong> ${data.email}</p><p><strong>Message:</strong></p><p>${data.message}</p><hr><p style=\"font-size:14px;color:#666\">This inquiry was submitted via the Cresco website contact form.</p></div>`
            };

            const response = await fetch('https://sendgrid.sysmio.com/api/mail/send', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            if (response.status === 429) {
                throw new Error('Too many requests. Please wait a moment and try again.');
            }

            if (!response.ok) {
                throw new Error('Failed to send email');
            }

            setSubmitStatus({ text: 'Success!', color: '#28a745' });
            setTimeout(() => {
                setSubmitStatus({ text: 'Submit', color: 'black' });
            }, 3000);
            e.target.reset();
        } catch (error) {
            console.error('Error sending form:', error);
            setSubmitStatus({ text: 'Error - Try Again', color: '#dc3545' });
            setTimeout(() => {
                setSubmitStatus({ text: 'Submit', color: 'black' });
            }, 3000);
        }
    };

    return (
        <div className="container-fluid px-4 px-md-5 py-5">
            <div className="row justify-content-center">
                <CardGroup className="col-12 col-md-10 col-lg-10">
                    <Card className="border-0">
                        <Card.Body className="h-100 d-flex flex-column">
                            <Card.Title>
                                <h1 className="display-4 text-start mb-0"
                                    style={{
                                        ...gradientTextStyle,
                                        fontFamily: 'Godber, sans-serif',
                                        fontSize: 'clamp(28px, 5vw, 40px)'
                                    }}>
                                    Contact Us
                                </h1>
                                <h2 className="text-start" 
                                    style={{ 
                                        fontFamily: 'Avenir, sans-serif', 
                                        fontSize: 'clamp(24px, 4vw, 36px)',
                                        fontWeight: 'bold' 
                                    }}>
                                    Reach Out to Us Now
                                </h2>
                            </Card.Title>
                            <form className="mt-4 flex-grow-1 d-flex flex-column h-100" onSubmit={handleSubmit}>
                                <div className="mb-1">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control rounded-0"
                                        placeholder="Your Name"
                                        required
                                        style={{
                                            height: '50px',
                                            fontFamily: 'Avenir, sans-serif'
                                        }}
                                    />
                                </div>
                                <div className="mb-1">
                                    <input
                                        type="tel"
                                        name="phone"
                                        className="form-control rounded-0"
                                        placeholder="Phone Number"
                                        required
                                        style={{
                                            height: '50px',
                                            fontFamily: 'Avenir, sans-serif'
                                        }}
                                    />
                                </div>
                                <div className="mb-1">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control rounded-0"
                                        placeholder="Email Address"
                                        required
                                        style={{
                                            height: '50px',
                                            fontFamily: 'Avenir, sans-serif'
                                        }}
                                    />
                                </div>
                                <div className="mb-3">
                                    <textarea
                                        name="message"
                                        className="form-control rounded-0"
                                        rows="5"
                                        placeholder="Your Message"
                                        required
                                        style={{
                                            fontFamily: 'Avenir, sans-serif',
                                            minHeight: '100px',
                                            resize: 'vertical'
                                        }}
                                    ></textarea>
                                </div>

                                <div className="mt-auto">
                                    <button
                                        type="submit"
                                        className="btn px-4 rounded-0"
                                        style={{
                                            backgroundColor: submitStatus.color,
                                            color: 'white',
                                            width: '100%',
                                            height: '50px',
                                            fontFamily: 'Avenir, sans-serif'
                                        }}
                                    >
                                        {submitStatus.text}
                                    </button>
                                </div>
                            </form>
                        </Card.Body>

                    </Card>
                    <Card className="border-0 d-none d-lg-block">
                        <Card.Body className="p-0" style={{ height: '100%', position: 'relative', overflow: 'hidden' }}>
                            <div className="shine-effect"></div>
                            <img
                                src="/contactcard.png"
                                alt="Contact Us"
                                className="img-fluid"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain'
                                }}
                            />
                        </Card.Body>
                    </Card>
                </CardGroup>
                
               
            </div>
        </div>
    );
}

export default ContactForm; 